export const linkSegmentClasses =
    'text-content-link no-underline hover:text-content-link-hover active:text-content-link-pressed'
